export default "__VITE_ASSET__DDnHMZyh__"